module.exports = __webpack_public_path__ + "static/img/ui-ia.555cd589.png";